module.exports = __webpack_public_path__ + "static/media/businessman.abbf463b.png";